import React, { useState } from "react";
// import ProductQuery from "../../api/ProductQuery";
import StoreApi from "../../api/StoreApi";
import ProductApi from "../../api/ProductApi";
import CustomDialog from "../CustomDialog";

import { Box, TextField, Button, CircularProgress } from "@mui/material";

const ProductSearch = ({ onProductsFetched, onStoresFetched }) => {
  const [styleCodes, setStyleCodes] = useState("");
  const [loading, setLoading] = useState(false);
  const [dialogMessage, setDialogMessage] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleSearch = async () => {
    setLoading(true);
    setDialogMessage("");
    setDialogOpen(false);

    try {
      const codes = styleCodes.split("\n").filter(Boolean);

      const [productResponse, storeResponse] = await Promise.all([
        ProductApi.fetchAll(codes.join(","), "partial_active"), // Fetch all products complete_active/partial_active
        StoreApi.fetchAll(),
      ]);

      if (
        !productResponse.data ||
        !Array.isArray(productResponse.data.activeProducts) ||
        !Array.isArray(productResponse.data.inactiveStyleColors) ||
        !Array.isArray(productResponse.data.nonExistentProducts)
      ) {
        throw new Error("Invalid product data format.");
      }

      // Extract data from the response
      const activeProducts = productResponse.data.activeProducts;
      const inactiveProducts = productResponse.data.inactiveStyleColors;
      const missingProducts = productResponse.data.nonExistentProducts;

      // // Combine active and inactive products to check for presence in the database
      // const allProducts = [...activeProducts, ...inactiveProducts];

      // // Map to group products by STYLE_COLOR
      // const groupedProducts = allProducts.reduce((acc, product) => {
      //   if (!acc[product.STYLE_COLOR]) {
      //     acc[product.STYLE_COLOR] = [];
      //   }
      //   acc[product.STYLE_COLOR].push(product);
      //   return acc;
      // }, {});

      // // Identify missing style colors (not in the database at all)
      // const allStyleColors = new Set(
      //   allProducts.map((product) => product.STYLE_COLOR)
      // );
      // const missing = codes.filter((code) => !allStyleColors.has(code));

      // // Identify inactive style colors (all variants are inactive)
      // const inactiveStyleColors = Object.keys(groupedProducts).filter(
      //   (styleColor) => {
      //     const variants = groupedProducts[styleColor];
      //     return variants.every((variant) => !variant.ACTV);
      //   }
      // );

      // Sort stores (prioritize ECOMMERCE store)
      const sortedStores = storeResponse.data.sort((a, b) =>
        a.STORE_NAME === "ECOMMERCE" ? -1 : b.STORE_NAME === "ECOMMERCE" ? 1 : 0
      );

      // Pass the fetched data to parent functions
      onProductsFetched(activeProducts, missingProducts, inactiveProducts);
      onStoresFetched(sortedStores);

      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setLoading(false);
      setDialogMessage(
        "Product(s) doesn't exist. Please try with valid product(s)."
      );
      setDialogOpen(true);
    }
  };

  const isButtonDisabled = !styleCodes.trim();

  return (
    <Box>
      {/* Custom Dialog */}
      <CustomDialog
        open={dialogOpen}
        onClose={() => setDialogOpen(false)}
        title="Error"
        message={dialogMessage}
        type="error"
        primaryButtonText="OK"
      />

      {/* Main Search Form */}
      <TextField
        label="Enter Style Codes (one per line)"
        multiline
        rows={10}
        fullWidth
        margin="normal"
        value={styleCodes}
        onChange={(e) => setStyleCodes(e.target.value.toUpperCase())}
      />
      <Button
        variant="contained"
        onClick={handleSearch}
        disabled={isButtonDisabled || loading}
        sx={{ display: "flex", alignItems: "center", gap: 1 }}
      >
        {loading ? <CircularProgress size={20} color="inherit" /> : "Build"}
      </Button>
    </Box>
  );
};

export default ProductSearch;
